(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PalabraClaveDetailController', PalabraClaveDetailController);

    PalabraClaveDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PalabraClave', 'Norma'];

    function PalabraClaveDetailController($scope, $rootScope, $stateParams, previousState, entity, PalabraClave, Norma) {
        var vm = this;

        vm.palabraClave = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:palabraClaveUpdate', function(event, result) {
            vm.palabraClave = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
